import { motion } from 'framer-motion';

export default function Loader3D({ size = 'md', className = '' }) {
  // Size variants
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  // Animation variants for the cube faces
  const cubeVariants = {
    animate: {
      rotateX: [0, 360],
      rotateY: [0, 360],
      transition: {
        duration: 2,
        ease: "linear",
        repeat: Infinity
      }
    }
  };

  // Animation variants for the shadow
  const shadowVariants = {
    animate: {
      scale: [1, 1.2, 1],
      opacity: [0.3, 0.1, 0.3],
      transition: {
        duration: 2,
        ease: "linear",
        repeat: Infinity
      }
    }
  };

  return (
    <div className={`relative flex items-center justify-center ${className}`}>
      <motion.div
        variants={cubeVariants}
        animate="animate"
        className={`relative preserve-3d ${sizes[size]}`}
      >
        {/* Front face */}
        <div className="absolute inset-0 bg-primary-500/80 backdrop-blur-sm rounded-lg transform-gpu translate-z-[1.5rem]" />
        
        {/* Back face */}
        <div className="absolute inset-0 bg-primary-600/80 backdrop-blur-sm rounded-lg transform-gpu -translate-z-[1.5rem]" />
        
        {/* Right face */}
        <div className="absolute inset-0 bg-primary-700/80 backdrop-blur-sm rounded-lg transform-gpu translate-x-[1.5rem] rotateY-90" />
        
        {/* Left face */}
        <div className="absolute inset-0 bg-primary-400/80 backdrop-blur-sm rounded-lg transform-gpu -translate-x-[1.5rem] rotateY-90" />
        
        {/* Top face */}
        <div className="absolute inset-0 bg-primary-300/80 backdrop-blur-sm rounded-lg transform-gpu -translate-y-[1.5rem] rotateX-90" />
        
        {/* Bottom face */}
        <div className="absolute inset-0 bg-primary-800/80 backdrop-blur-sm rounded-lg transform-gpu translate-y-[1.5rem] rotateX-90" />
      </motion.div>

      {/* Shadow */}
      <motion.div
        variants={shadowVariants}
        animate="animate"
        className={`absolute -bottom-4 bg-black/20 rounded-full ${sizes[size]} scale-[0.8] blur-md`}
      />
    </div>
  );
} 